<template>
  <div>
    <span>应用范围</span>
    <v-select style="width: 200px;"
              :data="appOptions"
              placeholder="请选择"
              :allowClear="false"
              @change="changeApp"
              v-model="appValue"></v-select>
    <span>所属板块</span>
    <v-select style="width: 200px;"
              :data="banOptions"
              placeholder="请选择"
              @change="changeBan"
              :allowClear="false"
              v-model="banValue"></v-select>
    <v-button type="primary"
              @click="search">查看</v-button>
    <v-button type="primary"
              @click="addHot">新增热门规格</v-button>
    <v-button type="warning"
              @click="save">保存修改</v-button>
    <div style="height:20px;"></div>
    <el-table :data="tableData"
              style="width: 100%">
      <el-table-column prop="id"
                       label="规格ID">
      </el-table-column>
      <el-table-column prop="name"
                       label="规格简称">
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text"
                     :disabled="scope.$index === 0"
                     @click="handlpUPClick(scope.row,scope.$index)"
                     size="small">上移</el-button>
          <el-button type="text"
                     :disabled="scope.$index === tableData.length-1"
                     @click="handleDownClick(scope.row,scope.$index)"
                     size="small">下移</el-button>
          <el-button type="text"
                     @click="changeSize(scope.row,scope.$index)"
                     size="small">变更</el-button>
        </template>
      </el-table-column>
    </el-table>
    <v-modal title="变更热门规格"
             :visible="visible"
             @ok="changeHot"
             @cancel="visible=false">
      <span>规格ID</span>
      <v-input v-model="changeID"></v-input>
      <span>规格简称</span>
      <v-input v-model="changeName"></v-input>
    </v-modal>
    <v-modal title="新增热门规格"
             :visible="addVisible"
             @ok="insertHot"
             @cancel="addVisible=false">
      <span>规格ID</span>
      <v-input v-model="addID"></v-input>
      <span>规格简称</span>
      <v-input v-model="addName"></v-input>
      <span>插入位置</span><br>
      <v-input-number :min="1"
                      :max="tableData.length+1"
                      style="width:100%"
                      v-model="addIndex"></v-input-number>
    </v-modal>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      addVisible: false,
      appOptions: [],
      appValue: '',
      banOptions: [],
      banValue: '',
      visible: false,
      tableData: [],
      changeID: '',
      changeName: '',
      changeIndex: 0,
      addID: '',
      addName: '',
      addIndex: 1
    }
  },
  methods: {
    insertHot () {
      let b = { id: this.addID, name: this.addName }
      this.tableData.splice(this.addIndex - 1, 0, b)
      this.addVisible = false
    },
    addHot () {
      if (this.tableData.length === 0) {
        this.$message['error']('请先查询')
        return
      }
      this.addID = ''
      this.addName = ''
      this.addIndex = 1
      this.addVisible = true
    },
    changeHot () {
      let b = { id: this.changeID, name: this.changeName }
      this.tableData.splice(this.changeIndex, 1, b)
      // this.tableData[this.changeIndex] = { id: this.changeID, name: this.changeName }
      this.visible = false
    },
    changeBan () {
      this.tableData = []
    },
    save () {
      // 组装数组
      if (this.banValue === '') {
        this.$message['error']('请选择板块')
        return
      }
      if (this.tableData.length === 0) {
        this.$message['error']('请先查询')
        return
      }
      let arr = []
      this.tableData.forEach(item => {
        let ar = []
        ar.push(+item.id)
        if (item.name) ar.push(item.name)
        arr.push(ar)
      })
      console.log(arr)
      axios.post('/dev/hot_specs', { hot_specs_type: this.banValue, spec_data: arr })
        .then(res => {
          if (res.data.code === 200) {
            this.$message['success']('保存成功')
            this.search()
          }
        })
    },
    handlpUPClick (row, index) {
      let a = this.tableData[index]
      let b = this.tableData[index - 1]
      this.tableData.splice(index, 1, b)
      this.tableData.splice(index - 1, 1, a)
    },
    handleDownClick (row, index) {
      let a = this.tableData[index]
      let b = this.tableData[index + 1]
      this.tableData.splice(index, 1, b)
      this.tableData.splice(index + 1, 1, a)
    },
    changeApp () {
      this.banValue = ''
      this.tableData = []
      this.getBan(this.appValue)
    },
    search () {
      if (this.banValue === '') {
        this.$message['error']('请选择板块')
        return
      }
      axios.get('/dev/hot_specs?hot_specs_type=' + this.banValue)
        .then(res => {
          let arr = []
          res.data.result.forEach(item => {
            let obj = {}
            obj.id = item[0]
            obj.name = item[1]
            arr.push(obj)
          })
          this.tableData = arr
        })
    },
    changeSize (row, index) {
      this.changeID = row.id
      this.changeName = row.name
      this.changeIndex = index
      this.visible = true
    },
    getApps () {
      axios.get('/dev/package_info').then(res => {
        let arr = []
        res.data.package_info.forEach(item => {
          let obj = {}
          obj.value = item.value
          obj.label = item.key
          arr.push(obj)
        })
        this.appOptions = arr
        this.appValue = arr[0].value
      })
    },
    getBan (key) {
      axios.get('/dev/hot_specs_type?package_key=' + key).then(res => {
        let arr = []
        res.data.result.forEach(item => {
          let obj = {}
          obj.value = item.value
          obj.label = item.key
          arr.push(obj)
        })
        this.banOptions = arr
      })
    }
  },
  created () {
    this.getApps()
    this.getBan('ALL')
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/format/format-hot.vue